import { useEffect, useState } from "react";
import { useAuthStore } from "@/store/authStore";
import { auth } from "@/api/endpoints";

/**
 * Bootstrap auth on app load: try a silent refresh (httponly cookie), then fetch
 * the current user. `ready` flips true once we know whether we're logged in.
 */
export function useAuthBootstrap() {
  const { user, setToken, setUser } = useAuthStore();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch("/api/v1/auth/refresh", {
          method: "POST",
          credentials: "include",
        });
        if (res.ok) {
          const data = (await res.json()) as { access_token: string };
          if (cancelled) return;
          setToken(data.access_token);
          const me = await auth.me();
          if (!cancelled) setUser(me);
        }
      } catch {
        /* not logged in */
      } finally {
        if (!cancelled) setReady(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [setToken, setUser]);

  return { ready, user };
}

export function useCurrentUser() {
  return useAuthStore((s) => s.user);
}

export function canEdit(role?: string | null): boolean {
  return role === "editor" || role === "owner";
}
